export class Patterns {
  static readonly email = '[a-zA-Z0-9._-]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}';
  static readonly password = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&._-]).{8,}$';
  static readonly userName = '^(?=.*[a-zA-Z])[a-zA-Z0-9._-]+$';
}
